import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { SignInComponent } from '../../autenticacion/sign-in/sign-in.component';
import { SignUpComponent } from '../../autenticacion/sign-up/sign-up.component';
import { AngularFireAuth } from '@angular/fire/auth';
import { RoutingVariablesService } from 'src/app/shared/services/routing-variables.service';
import { Router } from '@angular/router';
import { AngularFirestore } from '@angular/fire/firestore';

@Component({
  selector: 'menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})

export class MenuComponent implements OnInit {



  // media predeterminada
  logo: string = "assets/images/logos/logo.svg"
  defaultUserImage: string = "assets/images/default/default-user-image.jpg";
  user;
  token;
  primerNombre: string;

  // Menu responsive mobile
  menuOpen: number = 0;  

  // auxiliar buscador
  textoBusqueda: string = "";

  constructor(
    public authService: AuthService,
    public dialog: MatDialog,
    private afAuth: AngularFireAuth,
    private shared: RoutingVariablesService,
    private router: Router,
    private afs: AngularFirestore,
  ) { }



  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem('user'));
    this.token = JSON.parse(localStorage.getItem('token'));
    if(this.user) {
      this.primerNombre = this.user.nombreCompleto.split(' ')[0];
    }
  }

  buscarTexto() {
    const obj = { textoBusqueda: this.textoBusqueda };
    this.shared.pushData(obj);
    this.router.navigate(['/buscar']);
  }

  openLogIn() {
    const dialogRef = this.dialog.open(SignInComponent);

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openSignUp() {
    const dialogRef = this.dialog.open(SignUpComponent);
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  signOut() {
    this.authService.SignOut();
  }

}

